import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getFlights } from "../lib/api";

const Row = ({ f, kind }) => (
  <div className="flm-row" data-testid={`flight-${kind}-${f.flight}`}>
    <span className="flm-code">{f.flight}</span>
    <span className="flm-apt">{f.other}</span>
    <span className="flm-time">{f.time}{f.est ? ` · ${f.est}` : ""}</span>
    <span className={`flm-st ${f.state || "info"}`}>{f.status}</span>
  </div>
);

const FlightsMini = () => {
  const { data } = useQuery({ queryKey: ["flights"], queryFn: getFlights, refetchInterval: 60000 });
  const [tab, setTab] = useState(null);
  const air = data?.airspace || {};
  const arrivals = data?.arrivals || [];
  const departures = data?.departures || [];
  const craft = air.aircraft || [];
  const tabDefault = arrivals.length || departures.length ? "arrivals" : "radar";
  const active = tab || tabDefault;

  const rows = active === "arrivals" ? arrivals : active === "departures" ? departures : [];

  return (
    <div className="panel entrance flights-mini" data-testid="flights-panel">
      <div className="panel-head">
        <div className="panel-title">
          <div className="p-ic" style={{ background: "linear-gradient(135deg,#1e6ea7,#2a92d6)" }}>
            <i className="fa-solid fa-plane-up" />
          </div>
          Flights &amp; Airspace
        </div>
        <span className="pill neutral" data-testid="flights-airspace-count">{air.count ?? 0} in airspace</span>
      </div>

      <div className="flm-tabs" data-testid="flights-tabs">
        <button className={active === "arrivals" ? "on" : ""} onClick={() => setTab("arrivals")} data-testid="flights-tab-arrivals">
          <i className="fa-solid fa-plane-arrival" /> Arrivals <b>{arrivals.length}</b>
        </button>
        <button className={active === "departures" ? "on" : ""} onClick={() => setTab("departures")} data-testid="flights-tab-departures">
          <i className="fa-solid fa-plane-departure" /> Departures <b>{departures.length}</b>
        </button>
        <button className={active === "radar" ? "on" : ""} onClick={() => setTab("radar")} data-testid="flights-tab-radar">
          <i className="fa-solid fa-tower-broadcast" /> Radar <b>{craft.length}</b>
        </button>
      </div>

      {active !== "radar" ? (
        rows.length ? (
          <div className="flm-list">{rows.map((f, i) => <Row key={f.flight + i} f={f} kind={active} />)}</div>
        ) : (
          <div className="flm-empty" data-testid="flights-empty">No live {active} on approach right now — see <b>Radar</b> for aircraft in the region.</div>
        )
      ) : (
        <div className="flm-list" data-testid="flights-radar">
          {craft.length ? craft.slice(0, 18).map((a, i) => (
            <div key={a.flight + i} className="flm-row" data-testid={`radar-${a.flight}`}>
              <span className="flm-code">{a.flight}</span>
              <span className="flm-apt">{a.type}{a.reg && a.reg !== "—" ? ` · ${a.reg}` : ""}</span>
              <span className="flm-time">{a.alt_ft != null ? `${a.alt_ft.toLocaleString()} ft` : "—"}{a.speed_kts != null ? ` · ${a.speed_kts} kts` : ""}</span>
              <span className="flm-st info">{a.dist_km} km</span>
            </div>
          )) : <div className="flm-empty">No aircraft on radar near the island.</div>}
        </div>
      )}

      {data?.board_source && <div className="flm-src" data-testid="flights-source"><i className="fa-solid fa-satellite" /> {data.board_source}</div>}
    </div>
  );
};

export default FlightsMini;
